import { reportDone } from "src/ipc/reportScraping/reportDone";
import { IStartScrapingMessage } from "src/ipc/types/message/variants/StartScrapingMessage";
import { IScrapedJob } from "src/jobs/types/ScrapedJob";
import { reportError } from "src/ipc/reportScraping/reportError";
import { ProgressReporter } from "src/ipc/ProgressReporter/ProgressReporter";


export const onStartScraping = (totalSteps: number) => (
    callback:(args: string[], progressReporter: ProgressReporter) => Promise<IScrapedJob[]>
) => {
    const progressReporter = new ProgressReporter(totalSteps);

    process.on("message", async (message: IStartScrapingMessage) => {
        try{
            reportDone(await callback(message.payload.optionValues, progressReporter))
        }catch(e){
            if(e instanceof Error){
                reportError(e.message)
            }else if(typeof e === "string"){
                reportError(e)
            }
        }
        
    })
} 
